module.exports = __webpack_public_path__ + "img/loading.c2154782.gif";